import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { getProductName } from '@/utils/productHelper';
const SupportReleasePlanProductSet = new Set([
    'pro',
    'report',
    'bae91377ed7b45209cd48e076392cbbb' // Eureka
]);
let ProductService = class ProductService {
    constructor(productApi, i18n) {
        this.productApi = productApi;
        this.i18n = i18n;
        // 产品相关
        this.packageProducts = [];
        this.getProductionProducts = () => {
            if (this.packageProducts.length > 0) {
                return Promise.resolve(this.packageProducts);
            }
            return this.productApi.getProducts()
                .then(products => {
                this.packageProducts = _.filter(products, product => product.production);
                return _.filter(products, product => product.production);
            });
        };
        this.getAllProductionProducts = () => {
            return this.productApi.getProducts();
        };
        /**
         * 过滤掉只支持发版提示的产品
         */
        this.getReleasePlanProducts = () => {
            return this.getProductionProducts().then(products => {
                return _.filter(products, product => SupportReleasePlanProductSet.has(product.product_id));
            });
        };
    }
    get packageProductsOnSale() {
        return _.filter(this.packageProducts, item => item.on_sale);
    }
    get productIdMap() {
        return _.keyBy(this.packageProducts, 'product_id');
    }
    getProductById(product_id) {
        return this.productIdMap[product_id] || null;
    }
    getProductName(product_id) {
        return getProductName(this.getProductById(product_id), this.i18n.locale);
    }
    get OnSaleProductIds() {
        return _.map(this.packageProductsOnSale, item => item.id);
    }
    isOnSaleProduct(product_id) {
        return _.includes(this.OnSaleProductIds, product_id);
    }
};
ProductService = __decorate([
    injectable(),
    __param(0, inject(Symbols.ProductApi)),
    __param(1, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object])
], ProductService);
export { ProductService };
